module.exports = __webpack_public_path__ + "public/images/music.5c341c00ba434b95312021e61bd1ed5b.png";